export default {
    getSortType: (state) => (slotName) => {
      return state.sort[slotName ?? 'default']
    },
}